import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import COLORS from '../../themes/Colors'
import TYPOGRAPHY from '../../themes/Typography'
import METRICS from '../../themes/Metrics'
import { box, px2Rem } from '../../themes/Mixins'

// Defined component Button
const Button = ({ text, onPress, customStyle, ...props }) => {
  return (
    <button
      type={props.isSubmit ? 'submit' : 'button'}
      onClick={(e) => onPress(e)}
      style={customStyle}
      className={props.className}
    >
      {text}
    </button>
  )
}

// Defined styled component for button
export default styled(Button) `
  font-family: ${props => props.fontFamily || TYPOGRAPHY.TYPE.bold};
  font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.tiny};
  color: ${props => props.color || COLORS.white};
  margin: ${METRICS.btnMargin};
  display: block;
  cursor: pointer;
  border: none;

  :hover {
    opacity: 0.8;
  }

  ${props => props.type === 'danger' && css`
    ${props => box(
    props.width || `${px2Rem(309)}`,
    props.height || `${px2Rem(48)}`,
    props.bgColor || COLORS.btnHeader
  )};
  `};

  ${props => props.type === 'default' &&
    css`${props => box(
      props.width || `${px2Rem(160)}`,
      props.height || `${px2Rem(44)}`,
      props.bgColor || COLORS.bgtransparent
    )};

    color: ${props => props.color || COLORS.red};
    border: solid ${props => px2Rem(props.width || '3')}};
  `};

  ${props => props.type === 'info' &&
    css`${props => box(
      props.width || `${px2Rem(280)}`,
      props.height || `${px2Rem(70)}`,
      props.bgColor || COLORS.btnFooter
    )};

    font-family: ${props => props.fontFamily || TYPOGRAPHY.TYPE.light};
    border: solid ${props => props.width || `${px2Rem(2)}`};
  `};

  ${props => props.type === 'primary' &&
    css`${props => box(
      props.width || `${px2Rem(435)}`,
      props.height || `${px2Rem(70)}`,
      props.bgColor || COLORS.btnProcess
    )};

    font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.xSmall};
  `};

  ${props => props.type === 'dark' &&
    css`${props => box(
      props.width || `${px2Rem(140)}`,
      props.height || `${px2Rem(40)}`,
      props.bgColor || COLORS.btnGameDetail
    )};
  `};

  &:focus {
    outline: none;
  }
`

Button.propTypes = {
  text: PropTypes.string,
  onPress: PropTypes.func,
  isSubmit: PropTypes.bool
}

Button.defaultProps = {
  text: '',
  isSubmit: false
}



// WEBPACK FOOTER //
// ./src/components/common/Button.js